import { useSnackbar } from "notistack";
import { useState } from "react";
import { generateCallRecordingNoteDraft } from "./callRecordingsApi";

interface UseCallRecordingNoteDraft {
  readonly generatingNoteRecId: string | null;
  readonly noteDraftRecId: string | null;
  readonly noteDraftText: string;
  readonly handleCreateNoteDraft: (recId: string) => Promise<void>;
  readonly closeDraft: () => void;
}

export function useCallRecordingNoteDraft(): UseCallRecordingNoteDraft {
  const { enqueueSnackbar } = useSnackbar();

  const [generatingNoteRecId, setGeneratingNoteRecId] = useState<string | null>(null);
  const [noteDraftRecId, setNoteDraftRecId] = useState<string | null>(null);
  const [noteDraftText, setNoteDraftText] = useState("");

  const handleCreateNoteDraft = async (recId: string) => {
    try {
      setGeneratingNoteRecId(recId);
      const { text } = await generateCallRecordingNoteDraft(recId);
      setNoteDraftText(text);
      setNoteDraftRecId(recId);
    } catch (error) {
      enqueueSnackbar(
        error instanceof Error ? error.message : "Nie udało się wygenerować treści notatki z nagrania rozmowy",
        { variant: "error" },
      );
    } finally {
      setGeneratingNoteRecId(null);
    }
  };

  const closeDraft = () => setNoteDraftRecId(null);

  return { generatingNoteRecId, noteDraftRecId, noteDraftText, handleCreateNoteDraft, closeDraft };
}
